var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 19 18","fill":"none","width":_vm.width,"height":_vm.height}},[_c('circle',{attrs:{"cx":"9.5","cy":"9","r":"8.5","stroke":_vm.color}}),_c('path',{attrs:{"d":"M14.6136 8.90519L4.19664 8.90535","stroke":_vm.color,"stroke-width":"1.17067"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }